import React, { useEffect, useMemo, useState } from 'react'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { useCustomReducer } from '../../../../../base/customHooks'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import IPButton from '../../../../../components/IPButton'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { getDateByTimezoneOffset, toDateTimeLocal, uuidv4 } from '../../../../../base/utils/dataHelper'
import Translations from '../../../../../translations'
import { translate } from '../../../../../base/localization'
import IPInput from '../../../../../components/IPInput'
import Swal from 'sweetalert2'
import _ from 'lodash'
import { GetBankListApi } from '../services/getBankListApi'
import { IInsatallments, IMultiBankPosInsatallment, IParamPosInsatallment, PosProviderType, ProcedureInstalment } from '../models/models'
import { AddMultiBankParamPosInsatallmentApi } from '../services/addMultiBankParamPosInsatallmentApi'
import { AddMultiBankParatikaPosInsatallmentApi } from '../services/addMultiBankParatikaPosInsatallmentApi'
import { AddMultiBankAkOdePosInsatallmentApi } from '../services/addMultiBankAkOdePosInsatallmentApi'
import { UpdateParamPosInsatallmentApi } from '../services/updateParamPosInsatallmentApi'
import { DeleteByIdParamPosInsatallmentApi } from '../services/deleteByIdParamPosInsatallmentApi'
import InputCampaign from '../../../../../components/InputCampaign'
import { UpdateParatikaPosInsatallmentApi } from '../services/updateParatikaPosInsatallmentApi'
import { UpdateAkOdePosInsatallmentApi } from '../services/updateAkOdePosInsatallmentApi'
import { DeleteByIdParatikaPosInsatallmentApi } from '../services/deleteByIdParatikaPosInsatallmentApi'
import { DeleteByIdAkOdePosInsatallmentApi } from '../services/deleteByIdAkOdePosInsatallmentApi'
import { getCompanyApi } from '../../../components/api'
import { ICompany } from '../../../components/models/models'

interface IPosState {
  buttonName: string
  banks: ISelectOption[]
  companies: ISelectOption[]
  bank?: ISelectOption
  selectedBanks: ISelectOption[]
  guid: string
  selectedCompany?: ISelectOption
  isVodafone?: boolean
}

function Pos(props: BaseComponentWithContextProps) {
  const navigate = useNavigate()
  const routeLocation = useLocation()
  const [searchParams] = useSearchParams()
  const posType: PosProviderType = (searchParams.get('posType') as PosProviderType) || 'param'

  const getInitialState = (): IPosState => ({
    buttonName: 'Ekle',
    banks: [],
    companies: [],
    selectedBanks: [],
    guid: '',
    isVodafone: false,
  })

  const isEditMode = !!(routeLocation.state as any)?.installementData

  const t = translate(Translations)
  const [state, setState] = useCustomReducer<IPosState>(getInitialState())
  const [installment, setInstallment] = useState<ProcedureInstalment[]>([])
  const [startDate, setStartDate] = useState<any>(new Date())
  const [endDate, setEndDate] = useState<any>(undefined)

  const posNameMap = useMemo(() => ({ param: 'ParamPos', paratika: 'Paratika', akode: 'AkÖde' }), [])

  const posListUrl = () => `/admin/BankAndInstallementOperation/Pos/PosList?posType=${posType}${state.selectedCompany ? `&company=${state.selectedCompany.value}` : ''}`

  useEffect(() => {
    addInstallmentField()
    getBanks()
    getCompanies()
  }, [])

  useEffect(() => {
    if (state.banks.length > 0 && (routeLocation.state as any)?.installementData) {
      const data: IParamPosInsatallment = _.clone((routeLocation.state as any)?.installementData)
      const res: ProcedureInstalment[] = []
      data.Insatallments.forEach(ins => {
        const install = installmentAddNum.find(inst => String(inst.value) === String(ins.Installment))?.label
        res.push({
          Id: ins.Id,
          StateId: uuidv4(),
          InstalmentRate: { value: ins.Installment, label: install },
          TermDay: String(ins.InterestRate),
        })
      })
      setStartDate(data.StartDate)
      setEndDate(data.EndDate)
      setInstallment(res)
      setState({
        bank: { value: data.Insatallments[0].BankId, label: data.Insatallments[0].BankName },
        buttonName: 'Güncelle',
        guid: data.Guid,
        selectedCompany: { value: data.Company, label: state.companies.find(a => a.value == data.Company)?.label },
        isVodafone: data.IsVodafone || false,
      })
    }
  }, [state.banks, state.companies])

  useEffect(() => {
    if (state.companies.length > 0 && !(routeLocation.state as any)?.installementData) {
      const routeCompany = searchParams.get('company')
      if (routeCompany) {
        const match = state.companies.find(x => String(x.value) === routeCompany)
        if (match) setState({ selectedCompany: match })
      }
    }
  }, [state.companies])

  const getBanks = async () => {
    try {
      const api = new GetBankListApi({})
      const res =
        posType === 'paratika'
          ? await api.getParatikaBanks()
          : posType === 'akode'
            ? await api.getAkOdeBanks()
            : await api.getParamBanks()
      const banks = res?.map(x => ({ label: x.BankName, value: x.BankID })) || []
      setState({ banks })
    } catch (err: any) {
      Swal.fire({ icon: 'error', title: err.description, showConfirmButton: true, allowOutsideClick: false })
    }
  }

  const installmentAddNum = ['1', '2', '3', '4', '5', '6', '9', '12', '15', '18', '24'].map(value => ({
    value,
    label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', [value]),
  }))

  const vodafoneOptions: ISelectOption[] = [
    { value: 0, label: 'MIX' },
    { value: 1, label: 'Vodafone' },
  ]

  const getCompanies = async () => {
    try {
      const res: ICompany[] = await getCompanyApi()
      setState({ companies: (res || []).map(x => ({ label: x.Name, value: x.Code })) })
    } catch (err: any) {
      Swal.fire({ icon: 'error', title: err.description, showConfirmButton: true, allowOutsideClick: false })
    }
  }

  const handleInstalmentRate = (e, item) => {
    const tempInstallment = _.clone(installment)
    if (tempInstallment.length > 1) {
      if (
        tempInstallment.findIndex(
          temp => String(temp.InstalmentRate?.value) === String(e.value) && temp.StateId !== item.StateId
        ) > -1
      ) {
        Swal.fire({
          icon: 'error',
          title: 'Taksit daha önce seçilmiştir.',
          showConfirmButton: true,
          allowOutsideClick: true,
        })
        return
      }
      ; (tempInstallment.find(desc => desc.StateId === item.StateId) as any).InstalmentRate = e
        ; (tempInstallment.find(desc => desc.StateId === item.StateId) as any).Add = false
    } else {
      tempInstallment[0].InstalmentRate = e
    }
    setInstallment(tempInstallment)
  }

  const handleTermDay = (e, item) => {
    const tempInstallment = _.clone(installment)
    if (tempInstallment.length > 1) {
      ; (tempInstallment.find(desc => desc.StateId === item.StateId) as any).TermDay = e
        ; (tempInstallment.find(desc => desc.StateId === item.StateId) as any).Add = false
    } else {
      tempInstallment[0].TermDay = e
    }
    setInstallment(tempInstallment)
  }

  const removeInstallmentItem = item => {
    Swal.fire({
      icon: 'question',
      title: 'Silmek istediğinize emin misiniz?',
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed && (routeLocation.state as any)?.installementData) {
        props.showLoading()
        const deleteRes =
          posType === 'paratika'
            ? await new DeleteByIdParatikaPosInsatallmentApi({}).deleteByIdParatikaPosInsatallment(item.Id)
            : posType === 'akode'
              ? await new DeleteByIdAkOdePosInsatallmentApi({}).deleteByIdAkOdePosInsatallment(item.Id)
              : await new DeleteByIdParamPosInsatallmentApi({}).deleteByIdParamPosInsatallment(item.Id)
        props.hideLoading()
        Swal.fire({ icon: 'success', title: deleteRes as any, showConfirmButton: true, allowOutsideClick: false })
      }
      setInstallment(installment.filter(ins => ins.StateId !== item.StateId))
    })
  }

  const addInstallmentField = () => {
    setInstallment([
      ...installment,
      {
        StateId: uuidv4(),
        Id: 0,
        InstalmentRate: null,
        TermDay: '',
      },
    ])
  }

  const savePosInsatallment = async () => {
    if (!startDate || !endDate) {
      return Swal.fire({ icon: 'error', title: 'Lütfen boş alan bırakmayınız', showConfirmButton: true, allowOutsideClick: false })
    }

    // Ortak taksit şablonu doğrulaması
    let hasEmpty = false
    const template = installment.filter(ins => {
      if (!ins.InstalmentRate || !ins.TermDay) {
        hasEmpty = true
        return false
      }
      return true
    })

    if (hasEmpty || template.length === 0) {
      return Swal.fire({ icon: 'error', title: 'Lütfen boş alan bırakmayınız', showConfirmButton: true, allowOutsideClick: false })
    }

    if (!state.selectedCompany) {
      return Swal.fire({ icon: 'error', title: 'Lütfen şirket seçiniz.', showConfirmButton: true, allowOutsideClick: false })
    }

    // Güncelleme modu: tek banka (mevcut akış korunur)
    if (isEditMode) {
      if (!state.bank?.value) {
        return Swal.fire({ icon: 'error', title: 'Lütfen banka seçiniz.', showConfirmButton: true, allowOutsideClick: false })
      }

      const install: IInsatallments[] = template.map(ins => ({
        Id: ins.Id,
        BankId: Number(state.bank?.value),
        BankName: state.bank?.label || '',
        Installment: Number(ins.InstalmentRate?.value),
        InterestRate: Number(ins.TermDay),
      }))

      const req: IParamPosInsatallment = {
        Insatallments: install,
        StartDate: getDateByTimezoneOffset(startDate),
        EndDate: getDateByTimezoneOffset(endDate),
        Guid: state.guid || '',
        Company: Number(state.selectedCompany.value),
        IsVodafone: state.isVodafone,
      }

      try {
        props.showLoading()
        if (posType === 'paratika') await new UpdateParatikaPosInsatallmentApi({}).updateParatikaPosInsatallment(req)
        else if (posType === 'akode') await new UpdateAkOdePosInsatallmentApi({}).updateAkOdePosInsatallment(req)
        else await new UpdateParamPosInsatallmentApi({}).updateParamPosInsatallment(req)
        props.hideLoading()
        Swal.fire({ icon: 'success', title: 'İşlem başarılı', showConfirmButton: true, allowOutsideClick: false }).then(() => navigate(posListUrl()))
      } catch (err: any) {
        props.hideLoading()
        Swal.fire({ icon: 'error', title: err.description, showConfirmButton: true, allowOutsideClick: false })
      }
      return
    }

    // Ekleme modu: çoklu banka (her banka için ayrı tanım oluşturulur)
    if (!state.selectedBanks || state.selectedBanks.length === 0) {
      return Swal.fire({ icon: 'error', title: 'Lütfen en az bir banka seçiniz.', showConfirmButton: true, allowOutsideClick: false })
    }

    const templateInstallments: IInsatallments[] = template.map(ins => ({
      Id: 0,
      BankId: 0,
      BankName: '',
      Installment: Number(ins.InstalmentRate?.value),
      InterestRate: Number(ins.TermDay),
    }))

    const req: IMultiBankPosInsatallment = {
      Banks: state.selectedBanks.map(b => ({ BankID: Number(b.value), BankName: String(b.label) })),
      Insatallments: templateInstallments,
      StartDate: getDateByTimezoneOffset(startDate),
      EndDate: getDateByTimezoneOffset(endDate),
      Company: Number(state.selectedCompany.value),
      IsVodafone: state.isVodafone,
    }

    try {
      props.showLoading()
      if (posType === 'paratika') await new AddMultiBankParatikaPosInsatallmentApi({}).addMultiBankParatikaPosInsatallment(req)
      else if (posType === 'akode') await new AddMultiBankAkOdePosInsatallmentApi({}).addMultiBankAkOdePosInsatallment(req)
      else await new AddMultiBankParamPosInsatallmentApi({}).addMultiBankParamPosInsatallment(req)
      props.hideLoading()
      Swal.fire({ icon: 'success', title: 'İşlem başarılı', showConfirmButton: true, allowOutsideClick: false }).then(() => navigate(posListUrl()))
    } catch (err: any) {
      props.hideLoading()
      Swal.fire({ icon: 'error', title: err.description, showConfirmButton: true, allowOutsideClick: false })
    }
  }

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <div className='col-12 col-md-9 mb-2'>
              <span className='h4'>
                {posNameMap[posType]} Taksit {state.buttonName === 'Ekle' ? 'Ekleme' : 'Güncelleme'}
              </span>
            </div>
            <div className='col-12 col-md-2 mb-2'>
              <div className='buttonsuz'>
                <Link to={posListUrl()}>
                  <IPButton type='button' className='btn btn-primary' text='Listeye Dön' />
                </Link>
              </div>
            </div>
          </div>
          <div className='card-body'>
            <form id='id1' className='formform' noValidate>
              <div className='form-row'>
                <div className='col-lg-4'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <label className='labeltext'>Banka</label>
                    {!isEditMode && (
                      <div>
                        <a
                          role='button'
                          className='text-primary'
                          style={{ cursor: 'pointer', fontSize: '0.85rem', marginRight: '10px' }}
                          onClick={() => setState({ selectedBanks: state.banks })}
                        >
                          Tümünü Ekle
                        </a>
                        <a
                          role='button'
                          className='text-danger'
                          style={{ cursor: 'pointer', fontSize: '0.85rem' }}
                          onClick={() => setState({ selectedBanks: [] })}
                        >
                          Temizle
                        </a>
                      </div>
                    )}
                  </div>
                  {isEditMode ? (
                    <IPSelectBox
                      isClearable
                      options={state.banks}
                      value={state.bank}
                      onChangeSingle={option => setState({ bank: option })}
                    />
                  ) : (
                    <IPSelectBox
                      isMulti
                      isClearable
                      closeMenuOnSelect={false}
                      placeholder='Banka seçiniz'
                      options={state.banks}
                      value={state.selectedBanks}
                      onChangeMulti={options => setState({ selectedBanks: options || [] })}
                    />
                  )}
                </div>
                <div className='col-lg-2'>
                  <label className='labeltext'>Şirket</label>
                  <IPSelectBox
                    isClearable
                    placeholder='Şirket'
                    options={state.companies}
                    value={state.selectedCompany}
                    onChangeSingle={option => setState({ selectedCompany: option })}
                  />
                </div>
                {state.selectedCompany?.value === 1100 && (
                  <div className='col-lg-2'>
                    <label className='labeltext'>Bayi Tanım</label>
                    <IPSelectBox
                      options={vodafoneOptions}
                      value={vodafoneOptions.find(opt => opt.value === (state.isVodafone ? 1 : 0))}
                      onChangeSingle={option => setState({ isVodafone: option?.value === 1 })}
                    />
                  </div>
                )}
                <div className='col-lg-2'>
                  <label className='form-label'>Başlangıç Tarihi</label>
                  <InputCampaign
                    type='datetime-local'
                    value={toDateTimeLocal(startDate)}
                    onChange={e => setStartDate(e.target.value)}
                    isActive
                    id={''}
                    label={''}
                  />
                </div>
                <div className='col-lg-2'>
                  <label className='form-label'>Bitiş Tarihi</label>
                  <InputCampaign
                    type='datetime-local'
                    value={endDate ? toDateTimeLocal(endDate) : ''}
                    onChange={e => setEndDate(e.target.value)}
                    isActive
                    id={''}
                    label={''}
                  />
                </div>
              </div>
              {installment.map(item => (
                <div className='row m-t-5' key={item.StateId}>
                  <div className='col-3'>
                    <label className='labeltext'>Taksit Adedi</label>
                    <IPSelectBox
                      isClearable
                      name='InstalmentRate'
                      options={installmentAddNum}
                      value={item.InstalmentRate}
                      onChangeSingle={option => handleInstalmentRate(option, item)}
                    />
                  </div>
                  <div className='col-3'>
                    <label className='labeltext'>Vade(max)</label>
                    <IPInput
                      name='TermDay'
                      type='text'
                      value={item.TermDay}
                      onChange={e => handleTermDay(e.target.value?.replace(',', '.'), item)}
                    />
                  </div>
                  <div className='col-3'>
                    <label className='labeltext'></label>
                    <IPButton
                      onClick={() => removeInstallmentItem(item)}
                      type='button'
                      className='btn btn-danger m-t-5'
                      text='Sil'
                      disabled={installment.length < 2}
                    />
                  </div>
                  <div className='col-3'>
                    <label className='labeltext'></label>
                    <IPButton
                      onClick={() => addInstallmentField()}
                      type='button'
                      className='btn btn-success m-t-5'
                      text='Ekle'
                    />
                  </div>
                </div>
              ))}
              <div className='form-row mt-4' style={{ float: 'right' }}>
                <IPButton
                  text={state.buttonName}
                  type='button'
                  className='btn btn-success w-25 float-right'
                  onClick={savePosInsatallment}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(Pos)
